/** @param {number|null|undefined} d */
const dTekst = (d) => (typeof d === 'number' && Number.isFinite(d) ? `${d.toFixed(2)} d` : 'nog niet berekend')

/** @param {number|null|undefined} direction */
const richting = (direction) => {
    if (direction === 1) return 'groei'
    if (direction === -1) return 'daling'
    if (direction === 0) return 'geen verschil'
    return ''
}

/**
 * Per organisatie: wie levert wat aan deze cel, en in welke richting.
 *
 * `orgEffects` ontbreekt op een celdocument van vóór de uitbreiding; dan
 * vallen we terug op de bijdragen (naam + respondenten) en heet de
 * effectgrootte 'nog niet berekend' — nooit 0, dat zou een meting zijn.
 * AI-CONTEXT: See docs/pitfalls.md#ui-aggregate-collapses-nothing-into-zero
 *
 * @param {object} props
 * @param {Array<{orgId: string, name: string, respondents: number, d: (number|null), direction: (number|null)}>|null} props.orgEffects
 * @param {Array<{orgId: string, name: string, respondents: number}>} props.contributors - Uit de cel; terugval zonder orgEffects
 * @param {number} props.nRespondents - Totaal van de cel, voor het aandeel
 */
const CellOrgsTable = ({ orgEffects, contributors, nRespondents }) => {
    const rijen = orgEffects || contributors.map((c) => ({ ...c, d: null, direction: null }))
    if (rijen.length === 0) return <p className="intelligence-state">Geen bijdragende organisaties in deze cel.</p>
    return (
        <>
            {!orgEffects && (
                <p className="intelligence-state">
                    De effectgrootte per organisatie is voor deze cel nog niet berekend; dat gebeurt bij de volgende nachtelijke run.
                </p>
            )}
            <table className="sector-insight-details-table">
                <thead>
                    <tr>
                        <th>Organisatie</th>
                        <th>Respondenten</th>
                        <th>Aandeel</th>
                        <th>Effectgrootte</th>
                        <th>Richting</th>
                    </tr>
                </thead>
                <tbody>
                    {rijen.map((org) => (
                        <tr key={org.orgId}>
                            <td>{org.name || '(organisatie zonder naam)'}</td>
                            <td>{org.respondents}</td>
                            <td>{nRespondents > 0 ? `${Math.round((org.respondents / nRespondents) * 100)}%` : ''}</td>
                            <td>{dTekst(org.d)}</td>
                            <td>{richting(org.direction)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    )
}

export default CellOrgsTable
